// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".group[data-v-902f64f6] {\n  padding: 20px 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.group .title[data-v-902f64f6] {\n  color: rgba(0,0,0,0.88);\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n}\n.arrow[data-v-902f64f6] {\n  width: 24px;\n  height: 24px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
